import React from "react";

import { Selector as BettingTypeSelector } from "@gp/offer";

import { DropDownOption } from ".";

export type BetGroupOption = {
	abrv: string;
	displayName: string | undefined;
};

export function Dropdown(props: {
	isLive?: boolean;
	allAvailable?: BetGroupOption[];
	value: BettingTypeSelector;
	disabledOptions: string[];
	onChange: (value: string) => void;
}) {
	const wrapperClass = props.isLive
		? "offer__type__col offer--live__type__col"
		: "header--sport__item header--sport__type header--sport__types__item";

	const selectClass = props.isLive
		? "offer__type__select offer--live__type__select input input--sml input--select"
		: "header--sport__select input input--sml input--select";

	return (
		<div className={wrapperClass}>
			<select
				className={selectClass}
				value={props.value.name}
				onChange={(e) => props.onChange(e.target.value)}
			>
				{props.allAvailable?.map((bt) => (
					<DropDownOption
						key={bt.abrv}
						btOption={bt}
						disabledOptions={props.disabledOptions}
					/>
				))}
			</select>
		</div>
	);
}
